"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
class AssetDemand extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'assetDemand';
        this._demand = initParams.demand;
        this._time = initParams.time;
    }
    set demand(value) {
        console.error('Do not set objects this way');
    }
    get demand() {
        return this._demand;
    }
    set time(value) {
        console.error('Do not set objects this way');
    }
    get time() {
        return this._time;
    }
}
exports.default = AssetDemand;
//# sourceMappingURL=assetDemand.js.map